export default function PageHeader({ kicker, title, accent, description, image }) {
    return (
        <section className="relative pt-24 pb-20 overflow-hidden border-b border-white/5">
            {image && (
                <div className="absolute inset-0">
                    <img
                        src={image}
                        alt=""
                        className="w-full h-full object-cover opacity-30"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/90 via-[#0A0A0B]/70 to-[#0A0A0B]" />
                </div>
            )}
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {kicker && <p className="overline">{kicker}</p>}
                <h1 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[1.05] max-w-4xl">
                    {title}{" "}
                    {accent && (
                        <span className="italic text-[#C4A977]">{accent}</span>
                    )}
                </h1>
                {description && (
                    <p className="mt-6 text-[#A1A1AA] text-base lg:text-lg max-w-2xl leading-relaxed">
                        {description}
                    </p>
                )}
                <div className="hairline mt-10 max-w-md" />
            </div>
        </section>
    );
}
